import React, { useCallback } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';

import ConsumerConfirmFormInner from './ConsumerConfirmFormInner';
import SecurityPageWrapper from '../../security/security-page-wrapper/SecurityPageWrapper';
import { PROJECT_TYPES } from '../../constants';
import validate from '../../utils/validate';
import { consumerConfirmationYopValidation } from './validation';
import { getConsumerGenieGoData } from '../../redux/consumer/genie-go/consumerGenieGoActions';
import { getConsumerGenieData } from '../../redux/consumer/genie/consumerGenieActions';
import { getConsumerScoutData } from '../../redux/consumer/scout/consumerScoutActions';
import { consumerSonarLogin } from '../../redux/consumer/sonar/consumerSonarActions';
import { getConsumerResonanceData } from '../../redux/consumer/resonance/consumerResonanceActions';
import { getConsumerId8Data } from '../../redux/consumer/id8/consumerId8Actions';
import { getConsumerActiv8Data } from '../../redux/consumer/activ8/consumerActiv8Reducer';

const ConsumerConfirm = ({ onConfirm }) => {
  const dispatch = useDispatch();

  const pathname = useLocation().pathname;
  const { projectName } = useParams();

  const projectType = pathname.split('/')[1];

  const consumerConfirmInitialValues = {
    password: '',
  };

  const handleConfirmPassword = useCallback(
    async (values) => {
      if (onConfirm) {
        await onConfirm(values);
        return;
      }

      const projectTypeUpper = projectType.toUpperCase();

      if (CONFIRM_BY_PROJECT_TYPE[projectTypeUpper]) {
        const projectConfirmAction = CONFIRM_BY_PROJECT_TYPE[projectTypeUpper];
        await dispatch(
          projectConfirmAction({
            projectPassword: values.password,
            projectName,
          }),
        );
      }
    },
    [projectName, projectType, onConfirm, dispatch],
  );

  return (
    <SecurityPageWrapper backgroundStyle='login'>
      <Form
        initialValues={consumerConfirmInitialValues}
        onSubmit={handleConfirmPassword}
        subscription={{ submitting: true, pristine: true }}
        validate={(values) => validate(values, consumerConfirmationYopValidation())}
        render={({ handleSubmit }) => <ConsumerConfirmFormInner handleSubmit={handleSubmit} />}
      />
    </SecurityPageWrapper>
  );
};

export default ConsumerConfirm;

const CONFIRM_BY_PROJECT_TYPE = {
  [PROJECT_TYPES.SONAR]: consumerSonarLogin,
  [PROJECT_TYPES.RESONANCE]: getConsumerResonanceData,
  [PROJECT_TYPES.SCOUTV2]: getConsumerScoutData,
  [PROJECT_TYPES.GENIE]: getConsumerGenieData,
  [PROJECT_TYPES.GENIE_GO]: getConsumerGenieGoData,
  [PROJECT_TYPES.ID8]: getConsumerId8Data,
  [PROJECT_TYPES.ACTIV8]: getConsumerActiv8Data,
};
